import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import httpApiCall from "../../../service/api.service";
import toastr from "../../elements/toast";
import { useState } from "react";
import { eyeIconHide, eyeIconShow } from "../../../assets/assets";
import { getMd5Hash, getStorageValue, Regex , handleInputSpace } from "../../../service/shared.service";
import { Spinner } from "react-bootstrap";

const ChangePassword = () => {
  const [sppiner, setSppiner] = useState(false);
  const [visibility, setVisibility] = useState({
  current: false,
  new: false,
  confirm: false,
});

  const [imageState, setImageSrc] = useState({
    imgSrc: eyeIconHide,
    showPwd: true,
  });
  const updateImage = (e:any) => {    
    const src = !imageState.showPwd ? eyeIconHide : eyeIconShow;
    setImageSrc({
      imgSrc: src,
      showPwd: !imageState.showPwd,
    });
  };
  const userData = useSelector((state: any) => {
    const partnerProfile = state?.APIData?.partnerData?.partner_profile;
    return partnerProfile && partnerProfile.length > 0
      ? partnerProfile[0]
      : null;
  });
  const toastrService = new toastr(true);
  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required("Please enter current password").trim(),
    newPassword: Yup.string()
      .required("Please enter new password")
      .min(Regex.password_min_password_length, `New password must be at least ${Regex.password_min_password_length} characters long`).trim().max(Regex.password_max_password_length, `New password cannot be more than ${Regex.password_max_password_length} characters long`).trim()
      .matches( Regex.password_pattern , "New password must contain at least 8 characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character. Spaces are not allowed."),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Confirm password should be same as new password")
      .min(Regex.password_min_password_length, `New password must be at least ${Regex.password_min_password_length} characters long`).trim().max(Regex.password_max_password_length, `New password cannot be more than ${Regex.password_max_password_length} characters long`).trim()
      .required("Please enter confirm password").trim(),
  });

  const handleSubmit = (e: any, { resetForm }: any) => {
    const body: any = {
      access_token: userData.access_token,
      new_password: getMd5Hash(e.newPassword),
      old_password: getMd5Hash(e.currentPassword),
    };
    if (getStorageValue('partner_user_data')) {
      body['pu_id'] = (getStorageValue('partner_user_data').pu_id + '');
    }
    setSppiner(true);
    httpApiCall({ api: "change_password", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data && data.is_error === 0) {
          toastrService.showSuccess("Update Successfully");
          resetForm();
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };

  const togglePasswordVisibility = (field: 'current' | 'new' | 'confirm') => {
    setVisibility(p => ({ ...p, [field]: !p[field] }));
  };

  return (
    <div className="change-pswd">
      <div className="password-header">
        <h5>Change Password</h5>
      </div>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
        <Form>
          <div className="row">
            <div className="col-xl-6 col-12">
            <div className="my-3">
            <label htmlFor="">Current Password</label>
            <div className="hide_show">
            <Field
              type={visibility.current ? "text" : "password"}
              className="form-control"
              name="currentPassword"
              id="currentPassword"
               onKeyDown={handleInputSpace}
            /> 
            {}
            <img id="1" className="eye-icon IMG" src={ visibility.current ?  eyeIconShow : eyeIconHide} onClick={() => togglePasswordVisibility('current')}/>
            </div>
            <small className="text-danger">
              <ErrorMessage name="currentPassword" />
            </small>
          </div>
          <div className="my-3">
            <label htmlFor="">New Password</label>
            <div className="hide_show">
            <Field id="newpass" type={visibility.new ? "text" : "password"} className="form-control" name="newPassword"  onKeyDown={handleInputSpace} />
            <img id="2" className="eye-icon IMG" src={ visibility.new ?  eyeIconShow : eyeIconHide} onClick={() => togglePasswordVisibility('new')}/>
            </div>
            <small className="text-danger">
              <ErrorMessage name="newPassword" />
            </small>
          </div>
          <div className="my-3">
            <label htmlFor="">Confirm Password</label>
            <div className="hide_show">
            <Field
              type={ visibility.confirm  ? "text" : "password"}
              className="form-control"
              name="confirmPassword"
              id="confirmPassword"
               onKeyDown={handleInputSpace}
            />
           <img id="3" className="eye-icon IMG" src={  visibility.confirm ?  eyeIconShow : eyeIconHide} onClick={() => togglePasswordVisibility('confirm')}/>
            </div>
            <small className="text-danger">
              <ErrorMessage name="confirmPassword" />
            </small>
          </div>
            </div>
          </div>
        
          <div>
            <button id="update-password" disabled={sppiner} type="submit" className="btn-button">
              Update
              {sppiner && <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />}
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default ChangePassword;
